import { Auth } from 'aws-amplify';

const resendConfirmationCode = email => {
  if (!email) throw new Error('Email is missing');
  return Auth.resendSignUp(email.trim());
};

export default resendConfirmationCode;
